import { node, object } from "prop-types";
import React, { useCallback } from "react";
import context from "./context";

const DiProvider = ({ container, data, children }) => {
	const run = useCallback(
		fn => fn(container, data, run), //
		[container, data],
	);

	return container != null ? (
		<context.Provider value={{ container, data, run }}>{children}</context.Provider>
	) : (
		children
	);
};

DiProvider.propTypes = {
	container: object, // eslint-disable-line react/forbid-prop-types
	data: object, // eslint-disable-line react/forbid-prop-types
	children: node.isRequired,
};

export default DiProvider;
